import Gallery from "./Gallery";

const CantTalkRN = () => <Gallery imageNames={["can't talk rn.png"]} />;
export default CantTalkRN;
